module.exports = __webpack_public_path__ + "static/media/alert-charge.7f6b3f47.svg";